import { useMutation } from "@tanstack/react-query";

import type { CommentReportReason } from "@/entities/comment";
import { apiPost } from "@/shared/api";

/**
 * Жалоба на отзыв (доработки §6.2 «report abuse»).
 *
 * Кэш не трогается намеренно: жалоба ничего не меняет в том, что видит
 * жалующийся, — отзыв остаётся на месте до решения оператора или до порога
 * жалоб от разных людей. Перерисовать ленту значило бы намекнуть, что жалоба
 * сработала мгновенно.
 *
 * Повторная жалоба — не ошибка: бэкенд отвечает тем же успехом, а счётчик не
 * растёт. Экран поэтому просто показывает «Жалоба отправлена».
 */
export function useReportComment(commentId: number) {
  return useMutation({
    mutationFn: ({ reason, note }: { reason: CommentReportReason; note?: string }) =>
      apiPost("/api/v1/comments/{comment_id}/report", {
        params: { comment_id: commentId },
        body: { reason, ...(note ? { note } : {}) },
      }),
  });
}
